
const state = {
  userId: '',
  token: '',
  wxId: ''
}

const getters = {
  // Filtering currentUser
  currentUser: state => {
    return {
      userId: state.userId,
      token: state.token,
      wxId: state.wxId
    }
  }
}

const mutations = {
  getLocalUser (state) {
    state.userId = localStorage.getItem('userId')
    state.token = localStorage.getItem('token')
    state.wxId = localStorage.getItem('wxId')
  },
  setUser (state, payload) {
    state.userId = payload.userId
    state.token = payload.token
    state.wxId = payload.wxId
  },
  logout (state) {
    localStorage.removeItem('userId')
    localStorage.removeItem('token')
    localStorage.removeItem('wxId')
    state.userId = ''
    state.token = ''
    state.wxId = ''
  }
}


export default {
  state,
  getters,
  mutations
}
